import Fader from '@Shared/Fader';
import React from 'react';
import { Col, Container as Grid, Row } from 'react-bootstrap';
import Articles from './Articles';
import Docs from './Docs';
import Error from './Error';
import Notice from './Notice';
import StepsButton from './StepsButton';

const Bottom: React.FC = () => {

  return (
    <Grid className="main-section" fluid>
      <Error />
      <Notice />
      <Row>
        <Col xs={12}>
          <div>
            <Row>
              <Col md={8} style={{ paddingTop: 33 }} >
                <Articles />
              </Col>
              <Col md={4} style={{ paddingTop: 46 }}>
                <Fader>
                  <Docs />
                  <StepsButton />
                </Fader>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Grid>
  );
}

export default Bottom;